import React from "react";
import { Link } from "react-router-dom";
import ServiceCard from "../components/ServiceCard";
import cover from "../components/Createafull-width.png";

export default function Home({ t, langData }) {
  const services = langData.home2.services; // ← Array من JSON

  return (
    <>
          <div className="position-relative">

         <img src={cover} className="img w-100 rounded-0 " style={{ height: "1320px" }} alt="..." />
{/* النص فوق الصورة */}
<div className="hero-overlay bg-black opacity-75 position-absolute top-50 start-50 translate-middle text-center text-white px-4 px-md-5 w-75 w-md-50">
  <h1 className="display-1 fw-bold "> {/* كبرت من display-5 إلى display-4 */}
    {t("herotitle")}
  </h1>
  <p className="lead fs-5"> {/* خليت النص أكبر شوي */}
    {t("herodesc")}
  </p>

  <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mt-4">
    <Link to="/contact" className="btn btn-primary btn-lg px-4">
      {t("price")}
    </Link>
    <Link to="/services" className="btn btn-outline-light btn-lg px-4">
      {t("services")}
    </Link>
  </div>
</div>
</div>

      <section className=" bg-body-tertiary">
        <div className="container">
          <div className="text-center mb-4">
            <h2 className="fw-bold">{langData.home2.servicesTitle}</h2>
            <p className="text-secondary">{langData.home2.servicesSubtitle}</p>
          </div>
          <div className="row g-4">
            {services.map((s, idx) => (
              <div className="col-md-6 col-lg-3" key={idx}>
                <ServiceCard {...s} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
